 var windowWidth,lazyLink,lazyImages,lazySource,lazyBackground,lazyIframe,lazyScripts,navigator_platform,lazyLoadedJS,src,style,datasrc,urls,analytics,s,x,i,j,flag;
  function init(){flag&&(flag=0,load_all_js(),lazyLoadImg(),lazyLoadBackground(),lazyLoadIframe(),lazyLoadSource())}
  function isElementInViewport(t){
    var a=t.getBoundingClientRect();
    return a.top>=0&&a.left>=0&&a.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)
  }

  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
  
  function isElementInView(t){
    var a=t.getBoundingClientRect();
    return a.top<(window.innerHeight/2||document.documentElement.clientHeight/2) && a.bottom>(window.innerHeight/2||document.documentElement.clientHeight/2)
  }
  function lazyLoadLink(){
    lazyLink.forEach(function(t){
      t.href=null==t.dataset.href?t.href:t.dataset.href
    })
  }
  function lazyLoadImg(){
    lazyImages.forEach(function(t){
      null!=(src=windowWidth<600?null==t.dataset.mobsrc?t.dataset.src:t.dataset.mobsrc:t.dataset.src)&&(t.src=src),t.classList.remove("lazy2")
    })
  }
  function lazyLoadImg2(){
    lazyImages.forEach(function(t){
      isElementInViewport(t)&&(null!=(src=windowWidth<600?null==t.dataset.mobsrc?t.dataset.src:t.dataset.mobsrc:t.dataset.src)&&(t.src=src),t.classList.remove("lazy"))
    })
  }
  function lazyLoadSource(){
    lazySource.forEach(function(t){
      t.src=null==t.dataset.src?t.src:t.dataset.src
      t.parentElement.load();
    })
  }
  function lazyLoadBackground(){
    lazyBackground.forEach(function(t){
      lazybg=windowWidth<768?null==t.dataset.mobstyle?t.dataset.style:t.dataset.mobstyle:t.dataset.style,null!=lazybg&&(t.style=lazybg),t.classList.remove("lazybg")
    })
  }
  function lazyLoadIframe(){
    lazyIframe.forEach(function(t){
      t.src=null==t.dataset.src?t.src:t.dataset.src
    })
  }
  function lazyLoadScripts(){
    j!=lazyScripts.length&&("lazyload2"==lazyScripts[j].getAttribute("type")?(lazyScripts[j].setAttribute("type","lazyloaded"),void 0!==lazyScripts[j].dataset.src?((s=document.createElement("script")).src=lazyScripts[j].dataset.src,document.body.appendChild(s),s.onload=function(){j++,lazyLoadScripts()}):((s=document.createElement("script")).innerHTML=lazyScripts[j].innerHTML,document.body.appendChild(s),j++,lazyLoadScripts())):(j++,lazyLoadScripts()))
  }
  function lazyLoadCss(t){
    (s=document.createElement("link")).rel="stylesheet",s.href=t,document.getElementsByTagName("head")[0].appendChild(s)
  }
  function lazyLoadJS(t){
    if(lazyLoadedJS)return setTimeout(function(){lazyLoadJS(t)},200),!1;lazyLoadedJS=1,(s=document.createElement("script")).src=t,s.onload=function(){lazyLoadedJS=0},document.body.appendChild(s)
  }
  function wnwAnalytics() {
    var script2 = document.querySelectorAll(".analytics");
    script2.forEach(function(analyticsScript) {
      trekkie.integrations=false;
      s = document.createElement("script");
      s.innerHTML = analyticsScript.innerHTML;
      insertAfter(s, analyticsScript);
      analyticsScript.parentNode.removeChild(analyticsScript);
    });
  }
  document.addEventListener("DOMContentLoaded",function(){windowWidth=screen.width,lazyLink=document.querySelectorAll("link"),lazyImages=document.querySelectorAll("img.lazy2"),nolazyImages=document.querySelectorAll("img.lazy"),lazyBackground=document.querySelectorAll(".lazybg"),lazyIframe=document.querySelectorAll("iframe"),lazySource=document.querySelectorAll("source"),lazyScripts=document.getElementsByTagName("script"),navigator_platform=navigator.platform,i=0,j=0,flag=1,window.addEventListener("scroll",function(){init()}),window.addEventListener("mousemove",function(){init()}),window.addEventListener("touchstart",function(){init()}),"Linux x86_64"!=navigator_platform&&init(),setTimeout(function(){init()},10000)});

  function load_all_js() {

    console.log("Yes-optimization");
    setTimeout(function() {
      const wnw_load = new Event('wnw_load');
      window.dispatchEvent(wnw_load);
    }, 100);
    
    
    setTimeout(function() {
      var DOMContentLoaded2_event = document.createEvent("Event");
      DOMContentLoaded2_event.initEvent("DOMContentLoaded2", true, true);
      window.document.dispatchEvent(DOMContentLoaded2_event);
    }, 10000);
    lazyLink=document.querySelectorAll("link");
    lazyLoadLink();
    
    
    wnwAnalytics();

    j=0;
    lazyScripts = document.querySelectorAll("script[type=lazyload2]");
    lazyLoadScripts();
    
    lazySource = document.querySelectorAll("source");
    lazyLoadSource();
  }

  var script_loaded=!1;function loadJSscripts(){script_loaded||(void 0!==uLTS&&uLTS.disconnect(),void 0!==window.yett&&window.yett.unblock(),script_loaded=!0,document.querySelectorAll("iframe[data-src], script[data-src]").forEach(t=>{datasrc=t.dataset.src,null!=datasrc&&(t.src=datasrc)}),document.querySelectorAll("link[data-href]").forEach(t=>{datahref=t.dataset.href,null!=datahref&&(t.href=datahref)}),document.querySelectorAll("script[type='text/lazyload']").forEach(t=>{var e=document.createElement("script");for(a=0;a<t.attributes.length;a++){var r=t.attributes[a];e.setAttribute(r.name,r.value)}e.type="text/javascript",e.innerHTML=t.innerHTML,t.parentNode.insertBefore(e,t),t.parentNode.removeChild(t)}),document.dispatchEvent(new CustomEvent("asyncLazyLoad")),setTimeout(function(){document.dispatchEvent(new CustomEvent("loadBarInjector"))},3e3))}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscripts,!1)});  
